module.exports = __webpack_public_path__ + "img/cruise-location.5e390e3b.svg";